export default {
  title01: "वर्तमान मौसम",
  title02: "24 घंटे",
  title03: "10-दिन का मौसम पूर्वानुमान देखें",
  title04: "AQI",
  title05: "सभी जानकारी देखें",
  title06: "सूर्योदय और सूर्यास्त",
  title07: "चंद्रमा का चरण",
  title08: "अगली पूर्णिमा",
  title09: "अगला अमावस्या",
  title10: "दिन",
  title11: "रात",
  title12: "सूर्योदय",
  title13: "सूर्यास्त",
  title14: "चंद्रोदय",
  title15: "चंद्रास्त",
  title16: "स्रोत",
  title17: "शुरू",
  title18: "अंत",
  title19: "वर्तमान स्थान का उपयोग",
  title20: "शहर खोजें",
  title21: "रियलफील",
  title22: "रियलफील शेड",
  title23: "अभी",
  title24: "आज",
  title25: "रवि",
  title26: "सोम",
  title27: "मंगल",
  title28: "बुध",
  title29: "बृहस्पति",
  title30: "शुक्र",
  title31: "शनि",
  title32: "लोडिंग...",
  title33: "अभी",
  title34: "घंटा",
  title35: "प्रतिदिन",
  title36: "सूर्य और चाँद",
  title37: "हवा की गुणवत्ता",
  title38: "संपर्क करें: xlf50402@gmail.com",
  title39: "गोपनीयता समझौता",
  title40: "कॉपीराइट comfortweather.com 2020-2025 . सभी अधिकार सुरक्षित ",
  title41: "डेटा द्वारा उपलब्ध कराया गया",
  title42: "उच्चतम तापमान",
  title43: " न्यूनतम तापमान",
  title44: "स्वीकार करना",
  title45:
    "ComfortWeather का उपयोग करने के लिए धन्यवाद! अपने कानूनी अधिकारों और हितों की बेहतर सुरक्षा के लिए, कृपया उपयोग करने से पहले ",
  title46: "गोपनीयता नीति",
  title47: " को ध्यान से पढ़ें।",
  title48: "",
  title49: "संपर्क करें: xyjph123@gmail.com",
  title50: "कॉपीराइट 24hweather.com 2020-2025 . सभी अधिकार सुरक्षित ",
  title51:
    "24hweather का उपयोग करने के लिए धन्यवाद! अपने कानूनी अधिकारों और हितों की बेहतर सुरक्षा के लिए, कृपया उपयोग करने से पहले ",
};
